import React, { useContext, useEffect } from 'react';

import { LoadingPage } from '@exchange-frontends/components';

import { ContainerContext } from '../../../../utils';
import AppDetails from './AppDetails';

const PreviewAppDetails = ({ setEncounteredError, cloud }) => {
  const { ims, orgsLoaded } = useContext(ContainerContext);

  useEffect(() => {
    if (ims?.initialized && !ims.isSignedInUser()) {
      ims.signIn();
    }
  }, [ims]);

  // Wait for profile switch check to complete before rendering app details
  // to ensure the correct token is used to fetch the preview details
  if (!orgsLoaded) {
    return <LoadingPage />;
  }

  return <AppDetails setEncounteredError={setEncounteredError} cloud={cloud} isPreview />;
};

export default PreviewAppDetails;
